import React from 'react';
import { Datagrid, ReferenceManyField, TextField } from 'react-admin';

import ChangeComment from './Helpers/ChangeComment';
import DateField from '../Utils/DateField';
import DiffViewer from '../Utils/DiffViewer';

type Props = {
  basePath: string,
  record?: any,
  resource: string
};

const ChangeHistory = (props: Props) => (
  <div>
    <ReferenceManyField
      allowEmpty
      basePath={props.basePath}
      label="Change Histories"
      record={props.record}
      reference="helpers/change_histories"
      resource={props.resource}
      sort={{ field: 'created_at', order: 'DESC' }}
      target="reference_id"
    >
      <Datagrid>
        <ChangeComment label="Comment" name="comment" />
        <TextField name="method" source="method" />
        <DiffViewer name="diff" record={props.record} />
        <DateField label="Date" name="created_at" />
      </Datagrid>
    </ReferenceManyField>
  </div>
);

export default ChangeHistory;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/ChangeHistory.tsx